import React, { Component } from 'react'
import { connect } from 'react-redux'
import { identity, partial } from 'lodash'
import Modal from 'react-modal';

import { getAccessoriesVM } from 'state/viewModels'
import * as actions from 'ducks/modules/customize'
import AccessorySelection from 'components/AccessorySelection'
import AccessoriesView from 'components/AccessoriesView'
import ControlledRadioGroup from 'components/ControlledRadioGroup'
import NavWarning from 'containers/NavWarning'
import { TrackedButtonLink } from 'components/Buttons'

export class AccessoriesForm extends Component {
  constructor() {
    super();
    this.state = {
      accessoriesModalIsOpen: false,
      accessoryType: '',
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(accessoryType) {
    this.setState({
      accessoryType,
      accessoriesModalIsOpen: true,
    });
  }

  closeModal() {
    this.setState({accessoriesModalIsOpen: false});
  }

  render = (props) => (
  <div>
    <div className="customize-form-header">Accessories</div>
    <div className={"customize-form-section accessory-selection " + (this.props.selectedAccessoryType === 'grip' ? 'active' : '')}>
      { !(this.props.buyAPutter && this.props.buyAPutter.selected) && !this.props.grip.valid &&
        <div className="error">Grip Selection Required</div>
      }
        <AccessorySelection 
          className="desktop"
          selected={this.props.grip.selected} 
          accessoryType="grip" 
          onSelectAccessoryType={this.props.setAccessoryType}
          isError={this.props.showValidationWarnings && !this.props.grip.valid}
        />
        <AccessorySelection 
          className="mobile"
          selected={this.props.grip.selected} 
          accessoryType="grip" 
          onSelectAccessoryType={() => this.openModal("grip")}
          isError={this.props.showValidationWarnings && !this.props.grip.valid}
          onRemoveAccessory={this.props.onFieldChange}
        />
        {/*TODO: Check conditions for grip wraps. 
          are grips required to show grip wraps? 
          is a grip wrap selection required? 
          an option to deselect? */}
        {this.props.grip.selected &&
          <div className="grip-wrap-btns">
            <ControlledRadioGroup
              radioGroup="gripWrap"
              selected={this.props.gripWrap.selected}
              options={this.props.gripWrap.options}
              onChange={partial(this.props.onFieldChange, 'gripWrap')}
            />
          </div>
        }
    </div>
      
    <div className={"customize-form-section accessory-selection " + (this.props.selectedAccessoryType === 'shaftBand' ? 'active' : '')}>
      <AccessorySelection 
        className="desktop"
        selected={this.props.shaftBand.selected} 
        accessoryType="shaftBand" 
        onSelectAccessoryType={this.props.setAccessoryType}
        isError={this.props.showValidationWarnings && !this.props.shaftBand.valid}
      />
      <AccessorySelection 
        className="mobile"
        selected={this.props.shaftBand.selected} 
        accessoryType="shaftBand" 
        onSelectAccessoryType={() => this.openModal("shaftBand")}
        isError={this.props.showValidationWarnings && !this.props.shaftBand.valid}
        onRemoveAccessory={this.props.onFieldChange}
      />
    </div>
    <div className={"customize-form-section accessory-selection " + (this.props.selectedAccessoryType === 'headCover' ? 'active' : '')}>
      <AccessorySelection 
        className="desktop"
        selected={this.props.headCover.selected} 
        accessoryType="headCover" 
        onSelectAccessoryType={this.props.setAccessoryType}
        isError={this.props.showValidationWarnings && !this.props.headCover.valid}
      />
      <AccessorySelection 
        className="mobile"
        selected={this.props.headCover.selected} 
        accessoryType="headCover" 
        onSelectAccessoryType={() => this.openModal("headCover")}
        isError={this.props.showValidationWarnings && !this.props.headCover.valid}
        onRemoveAccessory={this.props.onFieldChange}
      />
    </div>
    <div className="customize-form-section">
      <TrackedButtonLink trackingData="Next:Authentication" className="next" to="auth">next: Authentication</TrackedButtonLink>
    </div>
    {<NavWarning when={!this.props.validation.valid}
        message="Please complete all selections above before going to another page." />
    }
    <Modal className="customizer accessories-modal modal-popup" overlayClassName="accessories-modal modal-overlay"
        isOpen={this.state.accessoriesModalIsOpen}
        onRequestClose={this.closeModal}
        contentLabel="Accessories Modal"
      > 
      <div className="accessories-modal-content">
        <div className="close-modal" onClick={this.closeModal}>X</div>
        <AccessoriesView accessoryType={this.state.accessoryType} closeModal={this.closeModal}/>
      </div>
    </Modal>
  </div>
  )
}

AccessoriesForm.defaultProps = {
  onFieldChange: identity,
  
};

const mapStateToProps = (state, ownProps) => {
  var p = { 
    ...getAccessoriesVM(state.customize),
    selectedAccessoryType : state.customize.selectedAccessoryType,
  }
  p.showValidationWarnings = state.app.blockedNavigation && !p.validation.valid
  return p;
}

const mapDispatchToProps = {
  onFieldChange: actions.selectField,
}

export default connect(mapStateToProps, mapDispatchToProps)(AccessoriesForm);